<template>
<div>
  <van-field 
    readonly 
    clickable
    :name="schema.name + '_' +schema.uniqid"
    :label="schema.label" 
    :placeholder="schema.placeholder" 
    :value="schema.value"
    :required="schema.required === true" 
    :rules="[{ required: schema.required === true ,message:'请选择'+schema.label}]"
    @click="showSelectPicker = true"
  />

  <van-popup v-model="showSelectPicker" position="bottom">
    <van-picker
      show-toolbar
      swipe-duration="300"
      :title="schema.label"
      :columns="schema.columns"
      @confirm="onSelectConfirm"
      @cancel="showSelectPicker = false"
    />
  </van-popup>
</div>
</template>

<script>
// import { Notify } from 'vant';

export default {
  name: 'selectPicker',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  data:function(){
    return {
      showSelectPicker:false,
    }
  },
  methods:{
    //确定选项
    onSelectConfirm:function(value, index){
      this.schema.value = value;
      this.schema.defaultIndex = index;
      this.showSelectPicker = false;
    },
  }
}
</script>

<style>

</style>